import { render, staticRenderFns } from "./ManageCreditorsReminders.vue?vue&type=template&id=0ec4919e&scoped=true"
import script from "./ManageCreditorsReminders.vue?vue&type=script&lang=js"
export * from "./ManageCreditorsReminders.vue?vue&type=script&lang=js"
import style0 from "./ManageCreditorsReminders.vue?vue&type=style&index=0&id=0ec4919e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec4919e",
  null
  
)

export default component.exports